import request from '@hotmart/request'
import React, { createContext, useContext } from 'react'
import { CONTEXT_REQUEST_IDENTIFIERS } from 'modules/context/context.constants'
import { CATEGORY, DataLayer, EVENT, GoogleAnalyticsDataLayer } from 'src/utils/google-analytics'
import { TItem } from './notification.types'

interface NotificationContextType {
  list: TItem[]
  get: {
    all: () => void
  }
  post: {
    handleItemMetrics: (args: { [key: string]: string | number }) => void
  }
  put: {
    updateItem: (ucode: string) => void
  }
}

const requestItens = dispatch => {
  request(CONTEXT_REQUEST_IDENTIFIERS.NOTIFICATION_LIST).then(data => {
    if (Array.isArray(data)) {
      dispatch(data)
    }
  })
}

const submitCustomMetricsClick = params => {
  request([CONTEXT_REQUEST_IDENTIFIERS.NOTIFICATION_CLICK_EVENT], {
    ...params,
    app: 'APP_BW'
  })
}

const updateItem = (ucode, undo) => {
  request([CONTEXT_REQUEST_IDENTIFIERS.NOTIFICATION_UPDATE], { ucode }).catch(undo)
}

const NotificationContext = createContext<NotificationContextType>({
  list: []
} as unknown as NotificationContextType)

export const NotificationProvider = props => {
  const [list, setList] = React.useState<TItem[]>([])
  const getList = () => {
    requestItens(setList)
  }
  const updateItemOnList = ucode => {
    const backup = [...list]

    setList(
      list.map((item: TItem) => ({
        ...item,
        read: item.ucode === ucode ? true : item.read
      }))
    )
    updateItem(ucode, () => setList(backup))
  }
  const handleItemMetrics = ({ ucode, cluster, type, subtype, label }) => {
    submitCustomMetricsClick({
      notificationUcode: ucode,
      cluster,
      action: 'CLICK',
      label
    })
    GoogleAnalyticsDataLayer.sendPageInteraction(
      new DataLayer(EVENT.INTERACTION, CATEGORY.HEADER, `Click:BellNotificationsItem:${type}:${subtype}`, ucode)
    )
  }

  const value = {
    get: { all: props.requestItens || getList },
    put: { updateItem: props.updateItem || updateItemOnList },
    post: { handleItemMetrics: props.handleItemMetrics || handleItemMetrics },
    list
  }

  return (
    <NotificationContext.Provider value={value as NotificationContextType}>
      {props.children}
    </NotificationContext.Provider>
  )
}

export const useNotification = () => useContext(NotificationContext)
